import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import API from 'src/api';
import { bulkUploadUsers } from '../actions';
import { BulkUploadUsersPayload } from '../types';
import { SagaAction } from '../../types';

function* bulkUploadUsersSaga({ payload }: SagaAction<BulkUploadUsersPayload>): SagaIterator {
  try {
    yield put(bulkUploadUsers.pending());
    const { tenantId, tenantUsers, sharedUsers } = payload;

    const response = yield call(API.bulkUpload, {
      tenantId,
      tenantUsers,
      sharedUsers,
    });

    yield put(bulkUploadUsers.success(response.data));
  } catch (error: any) {
    yield put(bulkUploadUsers.failure(error.message || 'Failed to upload users'));
  }
}

export default bulkUploadUsersSaga;
